import { useEffect, useState } from 'react';

/**
 * Returns true only once `active` has stayed true continuously for `delayMs`, and resets
 * as soon as `active` goes false.
 *
 * Used to delay the loading spinner: content usually loads in a few hundred ms and the
 * host webview shows its own spinner over that window, so we don't want to flash our own
 * spinner for quick loads — only if the wait actually runs long.
 */
export const useDelayedFlag = (active: boolean, delayMs: number): boolean => {
  const [elapsed, setElapsed] = useState(false);

  useEffect(() => {
    if (!active) {
      setElapsed(false);
      return undefined;
    }
    const timer = setTimeout(() => setElapsed(true), delayMs);
    return () => clearTimeout(timer);
  }, [active, delayMs]);

  return active && elapsed;
};
